import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const AuditTrail = React.lazy(async () => ({
    default: (await import('@oc/audit-trail/module')).AuditTrailModule
}))

export function AuditTrailComponent() {
    return <SuspenseWhileLoading LazyComponent={AuditTrail} />
}
